import React from 'react';
import MenuBar from './components/MenuBar';
import './SubNav.scss';

export default () => (
  <nav className="sub-nav">
    <MenuBar />
  </nav>
);
